import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import {
  IBeneficialCustomerParams,
  IBeneficialCustomerResult,
  ICreateBeneficialCustomerBody,
  ICreateBeneficialCustomerResult,
} from '../../interfaces/beneficialCustomer';

const getBeneficialCustomer = (
  params: IBeneficialCustomerParams
): Promise<IBeneficialCustomerResult> => {
  return bffServiceClient
    .get(`/merchantService/beneficiary/${params.merchantId}`)
    .then(getResult);
};

const createBeneficialCustomer = (
  body: ICreateBeneficialCustomerBody
): Promise<ICreateBeneficialCustomerResult> => {
  return bffServiceClient
    .post(`/merchantService/beneficiary`, body)
    .then(getResult);
};

export default { getBeneficialCustomer, createBeneficialCustomer };
